// types
import { IHeatPumpCOP } from './types'
import { ParagraphMedium } from 'baseui/typography';
// components
import { CounterType } from '../../Devices/CounterType';
import { LoadingView } from '../../../components/LoadingView'
import { useEffect, useMemo, useState } from 'react';
import { ICounter } from '../../../automationObjects/Devices/Counter';
import { FormattedMessage, useIntl } from 'react-intl';
import { COPChart } from './';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { defaultCurrencyCode } from '../../../utils/currency';
import { useGetRelationsOutByIdQuery, RELATION_TYPE, useGetRelationsInByIdQuery } from '../../../services/objects';
import { addMonths, addDays } from 'date-fns';
import { useGetByIdAndTimeSummarizedQuery } from '../../../services/historicalData';
import { number } from 'currency-codes';
import { ValueDisplay, ValueDisplayWithLabel } from '../../components/ValueDisplay';

interface IState {
    start: Date,
    end: Date
}

export function SmallPanel(props: IHeatPumpCOP) {

    const intl = useIntl();
    const { data: objectsOut, isLoading, isSuccess, error, refetch } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: RELATION_TYPE.Feeds })

    const { data: objectsIn, isLoading: isLoadingOut, isSuccess: isSuccessOut, error: errorOut, refetch: refetchOut } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: RELATION_TYPE.IsFedBy })

    const [cOP, setCOP] = useState(0);
    const current = new Date();
    const [state, setState] = useState<IState>({
        start: addMonths(new Date(current.getFullYear(), current.getMonth(), current.getDate()), -12),
        end: addDays(new Date(current.getFullYear(), current.getMonth(), current.getDate()), 1),
    });

    const itemsOut = useMemo(() => objectsOut?.sort((a: ICounter, b: ICounter) => a.counterMedium > b.counterMedium ? 1 : -1) ?? [], [objectsOut]);
    const itemsIn = useMemo(() => objectsIn?.sort((a: ICounter, b: ICounter) => a.counterMedium > b.counterMedium ? 1 : -1) ?? [], [objectsIn]);

    const { data: data1 } = useGetByIdAndTimeSummarizedQuery(
        {
            id: itemsIn[0]?.id,
            resourceGroupId: itemsIn[0]?.resourceGroupId,
            propertyName: 'valueDelta',
            start: state.start.toISOString(),
            end: state.end.toISOString(),
            summarizeBy: 'month'
        });
    const { data: data2 } = useGetByIdAndTimeSummarizedQuery(
        {
            id: itemsOut[0]?.id,
            resourceGroupId: itemsOut[0]?.resourceGroupId,
            propertyName: 'valueDelta',
            start: state.start.toISOString(),
            end: state.end.toISOString(),
            summarizeBy: 'month'
        });

    useEffect(() => {

        if (!data1 || !data2 || data1.length == 0 || data2.length == 0)
            return;

        var arr2 = [...data2]
        if (data2.length > data1.length)
           arr2.splice(0, data2.length - data1.length)

        var arr1 = [...data1]
        if (data1.length > data2.length)
            arr1.splice(0, data1.length - data2.length)

        const sumIn = arr1.reduce(function (r, a, i) { return r + a.sumValue }, 0)
        const sumOut = arr2.reduce(function (r, a, i) { return r + a.sumValue }, 0)

        setCOP(sumOut / sumIn)


    }, [data1, data2])

    return (

        <ValueDisplayWithLabel label={intl.formatMessage({ id: "heatpumpCOP.annualPerformanceFactor", defaultMessage: "AnnualPerformanceFactor" })} value={cOP} dimension=''></ValueDisplayWithLabel>

    );
}

